import {Component, OnInit} from '@angular/core';
import {PurchaseProductHistoryService} from '../../../shared/services/purchase-product-history.service';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-purchase-products-history',
  templateUrl: './purchase-products-history.component.html',
  styleUrls: ['./purchase-products-history.component.scss']
})
export class StockistPurchaseProductsHistoryComponent implements OnInit {
  submitting = false;
  purchaseProductsHistory = [];
  showSearch: any = false;
  searchForm: FormGroup;
  pagination = {
    page: 1,
    total: null,
    perpage: 15,
    pages: null
  };

  constructor(public purchaseProductHistoryService: PurchaseProductHistoryService,
              private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.searchForm = this.fb.group({
      'invoice_no': [''],
      'total_amount': [''],
      'payment_mode': ['']
    });
    this.get();
  }

  get(params: any = {}) {
    params.page = this.pagination.page;
    params.perpage = this.pagination.perpage;
    this.submitting = true;
    this.purchaseProductsHistory = [];
    this.purchaseProductHistoryService.get(params).subscribe(data => {
      if (data && data['data'] && data['data'].length > 0) {
        this.purchaseProductsHistory = data['data'];
        this.pagination = {
          page: data['pagination'].page,
          total: data['pagination'].total,
          perpage: data['pagination'].perpage,
          pages: data['pagination'].pages,
        };
        this.triggerScroll();
      } else {
        this.purchaseProductsHistory = [];
      }
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  navigateTo(data) {
    window.open(data.invoice_url, '_blank')
  }

  triggerScroll() {
    window.scrollTo(500, 500);
    window.scrollTo(500, 0);
  }

  onPageChange(page) {
    this.pagination.page = page;
    this.get();
  }

  search() {
    this.pagination = {
      page: 1,
      total: null,
      perpage: 15,
      pages: null
    };
    let params = {
      'invoice_no': (this.searchForm && this.searchForm.value) ? this.searchForm.value.invoice_no: '',
      'total_amount': (this.searchForm && this.searchForm.value) ? this.searchForm.value.total_amount: '',
      'payment_mode': (this.searchForm && this.searchForm.value) ? this.searchForm.value.payment_mode: ''
    };
    this.get(params);
  }
}
